export default function NoRecord() {
  return (
    <div style={{ textAlign: 'center' }}>
      <p>No Record Found</p>
    </div>
  );
}
